import { Box, Grid, Tooltip } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useContext } from "react";
import { AppContext } from "../context";

export default function PlanInfo() {
  const { plan } = useContext<any>(AppContext);

  return (
    <Grid
      container
      direction="column"
      sx={{
        height: "100%",
        maxWidth: 500,
        border: 2,
        borderColor: "primary.main",
        borderRadius: 3,
        alignItems: "center",
        margin: "auto",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        sx={{ textAlign: "center" }}
      >
        <Typography variant="h6" color="primary.main">
          Plano Selecionado
        </Typography>

        <Typography variant="subtitle1" color="primary.main">
          {plan.plan_selected}: R$ {plan.price}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "80%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          mb: 2,
        }}
      >
        {plan.plans_description.map((product: any) => (
          <Box sx={{ width: "100%", display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                backgroundColor: "primary.main",
                borderRadius: 1.5,
                p: 1,
                m: 0.7,
                display: "flex",
                justifyContent: "center",
                width: "20px",
                height: "20px",
              }}
            >
              <img
                src={product.productDetailIconUrl}
                alt="icon"
                width="20px"
                height="20px"
              />
            </Box>
            <Tooltip
              title={product.productDetailDescrition}
              sx={{ cursor: "default" }}
            >
              <Typography variant="body2">
                {product.productDetailName}
              </Typography>
            </Tooltip>
          </Box>
        ))}
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          sx={{ textAlign: "center", ml: 5 }}
        >
          {plan.product_description && (
            <Typography
              sx={{
                color: "primary.main",
                maxWidth: 200,
                fontSize: 15,
                fontWeight: 800,
              }}
            >
              {plan.product_description}
            </Typography>
          )}
        </Box>
      </Box>
    </Grid>
  );
}
